/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import * as formatter from 'mt-react-common/utils/formatter';
import { t } from 'utils/translates';

class DateRangeInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDates: {
        startValueFrom: props.startValueFrom,
        startValueTo: props.startValueTo
      },
      rangeValues: {
        valueFrom: props.startValueFrom,
        valueTo: props.startValueTo
      }
    };
  }

  componentDidMount() {
    // eslint-disable-next-line no-undef
    $(`#${this.props.idElement}`)
      .datepicker({
        dateFormat: 'dd.mm.yyyy',
        todayBtn: 'linked',
        language: 'ru',
        endDate: '+0d',
        autoclose: true,
        calendarWeeks: !0,
        todayHighlight: !0
      })
      .on('changeDate', e => {
        if (e.target.name === 'start') {
          this.setState({
            rangeValues: {
              valueFrom: e.date ? formatter.dateFormatSql(e.date) : null,
              valueTo: this.state.rangeValues.valueTo
            }
          });
        } else if (e.target.name === 'end') {
          this.setState({
            rangeValues: {
              valueFrom: this.state.rangeValues.valueFrom,
              valueTo: e.date ? formatter.dateFormatSql(e.date) : null
            }
          });
        }
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      ((prevState.rangeValues.valueFrom !== this.state.rangeValues.valueFrom ||
        prevState.rangeValues.valueTo !== this.state.rangeValues.valueTo) &&
        (this.state.rangeValues.valueFrom !== null &&
          this.state.rangeValues.valueTo !== null) &&
        (this.state.rangeValues.valueFrom !== '' &&
          this.state.rangeValues.valueTo !== '')) ||
      ((prevState.rangeValues.valueFrom !== null ||
        prevState.rangeValues.valueTo !== null) &&
        (this.state.rangeValues.valueFrom === null &&
          this.state.rangeValues.valueTo === null))
    ) {
      // console.log(this.state.rangeValues);
      this.props.handleChangeRangeValues(this.state.rangeValues);
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="form-group">
          <div style={{ float: 'left' }}>
            <div
              id={this.props.idElement}
              className="input-daterange input-group datepicker datepicker-inline"
            >
              <input
                autoComplete="off"
                type="text"
                className="form-control"
                name="start"
                placeholder={t('С даты')}
                defaultValue={
                  this.state.rangeValues.valueFrom
                    ? formatter.dateFormat4(this.state.rangeValues.valueFrom)
                    : ''
                }
              />
              <span className="input-group-addon">–</span>
              <input
                autoComplete="off"
                type="text"
                className="form-control"
                name="end"
                placeholder={t('По дату')}
                defaultValue={
                  this.state.rangeValues.valueTo
                    ? formatter.dateFormat4(this.state.rangeValues.valueTo)
                    : ''
                }
              />
            </div>
          </div>
          <div
            style={{ float: 'right', paddingLeft: '10px', paddingTop: '7px' }}
          >
            <a
              href=""
              title={t('Очистить')}
              onClick={e => {
                e.preventDefault();
                // eslint-disable-next-line no-undef
                $(`#${this.props.idElement} [name='start']`).datepicker(
                  'clearDates'
                );
                // eslint-disable-next-line no-undef
                $(`#${this.props.idElement} [name='end']`).datepicker(
                  'clearDates'
                );

                this.setState({
                  rangeValues: {
                    valueFrom: null,
                    valueTo: null
                  }
                });
              }}
            >
              <i className="fa fa-times text-danger" />
            </a>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

DateRangeInput.defaultProps = {
  startValueFrom: null,
  startValueTo: null
};

DateRangeInput.propTypes = {
  idElement: PropTypes.string.isRequired,
  startValueFrom: PropTypes.string,
  startValueTo: PropTypes.string,
  handleChangeRangeValues: PropTypes.func.isRequired
};

export default withRouter(DateRangeInput);



// WEBPACK FOOTER //
// ./src/components/Common/Inputs/DateRangeInput/DateRangeInput.js